import { c as _c } from "react/compiler-runtime";
import { useQuery } from '@tanstack/react-query';
export type WikiGenerationProgressItem = {
  id: string;
  wikiId: string;
  stage: string;
  message: string | null;
  progressPercent: number | null;
  metadata: any | null;
  createdAt: string;
  updatedAt: string;
};
export function useWikiGenerationProgress(wikiId, t0) {
  const $ = _c(9);
  const enabled = t0 === undefined ? true : t0;
  let t1;
  if ($[0] !== wikiId) {
    t1 = ["wiki-generation-progress", wikiId];
    $[0] = wikiId;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const t2 = !!wikiId && enabled;
  let t3;
  if ($[2] !== wikiId) {
    t3 = async () => {
      if (!wikiId) {
        return [];
      }
      const params = new URLSearchParams({
        wikiId
      });
      const res = await fetch(`/api/wiki/progress?${params.toString()}`);
      if (res.ok) {
        const progress = await res.json();
        return progress || [];
      }
      return [];
    };
    $[2] = wikiId;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const t4 = enabled ? 4000 : false;
  let t5;
  if ($[4] !== t1 || $[5] !== t2 || $[6] !== t3 || $[7] !== t4) {
    t5 = {
      queryKey: t1,
      enabled: t2,
      queryFn: t3,
      refetchInterval: t4,
      refetchIntervalInBackground: false,
      staleTime: 1000,
      gcTime: 30000
    };
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  return useQuery(t5);
}